module.exports = "/images/unlockIcon.svg?6a237aa4d418bd341317442c5d335197";